module.exports = __webpack_public_path__ + "img/phone.2238eb52.png";